import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const PtNgfwNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="ptngfw" />;
};
